import { useState, type FormEvent } from 'react';
import { heroHighlights, heroImage } from '@/mocks/homeData';

export default function Hero() {
  const [keyword, setKeyword] = useState('');
  const [hint, setHint] = useState('');

  const handleExplore = (e: FormEvent) => {
    e.preventDefault();
    const value = keyword.trim();
    setHint(value ? `已把你的「${value}」记下来，向下浏览对应片单分区即可快速对号入座。` : '先输入片名或题材，再向下浏览片单分区。');
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-24 md:pt-28">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-20 top-40 h-64 w-64 rounded-full bg-accent-100/50 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pb-14 md:pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="jinju-reveal">
            <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-800">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-sparkling-2-line text-sm"></i>
              </span>
              专题合集浏览 · 每周更新片单
            </span>

            <h1 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
              好看的电影
              <br />
              金桔影院帮你一次挑齐
            </h1>

            <p className="mt-5 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
              这里把金桔影院最新电影与热门影片整理成一份份可读的片单，从高分佳作到冷门宝藏，再按电影排行榜帮你快速锁定目标，想看大片还是小众剧情片，都能在这里找到方向。
            </p>

            <form onSubmit={handleExplore} className="mt-7 flex flex-col sm:flex-row gap-3 sm:items-center max-w-xl">
              <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3.5 py-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                  <i className="ri-search-line text-lg"></i>
                </span>
                <input
                  type="text"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="输入片名、题材或影人，例如「悬疑」「纪录」"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </div>
              <button
                type="submit"
                className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 cursor-pointer"
              >
                帮我找片
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </button>
            </form>
            <p className="mt-2.5 min-h-[1.25rem] text-xs text-secondary-600">{hint}</p>

            <div className="mt-7 grid grid-cols-3 gap-3 max-w-xl">
              {heroHighlights.map((item) => (
                <div key={item.label} className="rounded-lg border border-background-200 bg-background-100/70 px-3.5 py-3">
                  <p className="font-heading text-lg md:text-xl font-semibold text-foreground-950">{item.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="jinju-reveal">
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
                <img
                  src={heroImage}
                  alt="金桔影院热门影片片单主题图"
                  title="金桔影院热门影片片单"
                  className="h-[360px] md:h-[520px] w-full object-cover object-top"
                />
              </div>

              <div className="absolute -bottom-6 left-4 right-4 md:left-6 md:right-auto md:w-[320px] rounded-xl border border-background-200 bg-background-50/95 p-4 backdrop-blur">
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-700">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-fire-line text-sm"></i>
                    </span>
                    实时热播榜 · 榜首
                  </span>
                  <span className="text-xs text-foreground-400">更新于今天</span>
                </div>
                <p className="mt-3 font-heading text-base font-semibold text-foreground-950">长夜将尽的列车</p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-600">
                  <span className="inline-flex items-center gap-1">
                    <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                      <i className="ri-star-fill text-sm"></i>
                    </span>
                    9.1
                  </span>
                  <span>剧情 / 悬疑</span>
                </div>
                <a href="#ranking" className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-700 cursor-pointer">
                  查看完整排行榜
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}